function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 2,
  fill: "none",
  viewBox: "0 0 12 2",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#1C1B1F",
  d: "M1.042 1.833a.84.84 0 0 1-.615-.26.84.84 0 0 1-.26-.615.84.84 0 0 1 .26-.614.84.84 0 0 1 .615-.261h9.916q.354 0 .615.261a.84.84 0 0 1 .26.614.84.84 0 0 1-.26.615.84.84 0 0 1-.615.26z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-remove.svg";
export { SvgComponent as ReactComponent };